import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { formatURL, getUrlParams, changeTitle, isSameDaySearch } from '../../utils';
import dataLayer from '../../utils/dataLayer';
import {
  getCouponData,
  getPaymentMethods,
  getPurchaseData,
  getProductCoverage,
  listBenefits,
  fetchPaymentMethodsService,
} from '../../apiCalls';
import {
  fetchPlansPurchase,
  setQuotationParams,
  openModalFranchise,
  closeModalFranchise,
  openModalStudent,
  closeModalStudent,
  cleanErrors,
  setInfosProspectInPurchase,
  openModalTravelRenewal,
  openModalRenewalFranchise,
  closeModalTravelRenewal,
  closeModalPlanRules,
  closeModalFailPayment,
  closeModalRenewalFranchise,
  openModalReceptiveProduct,
  closeModalReceptiveProduct,
  openModalNotCovidCoverage,
  closeModalNotCovidCoverage,
  getPaymentMethodsAvaliable,
} from '../../actions/purchaseActions';

import store from '../../store';

import './Purchase.css';
import Loading from '../../components/standard/loading/Loading';
import StagePayment from '../../components/purchase/stage_payment/StagePayment';
import AccordionGroup from '../../components/purchase/accordion/Accordion';
import PaymentInfo from '../../components/purchase/payment_info/PaymentInfo';
import ModalFranchise from '../../components/purchase/modal_franchise/ModalFranchise';
import ModalStudent from '../../components/purchase/modal_student/ModalStudent';
import ModalSafetypay from '../../components/purchase/modal_safetypay/ModalSafetypay';
import ModalOperatorConfirmation from '../../components/purchase/modal_operator_confirmation/v2/ModalOperatorConfirmationV2';
import InsuredRegister from '../../components/purchase/insured_register/InsuredRegister';
import PurchaseContact from '../../components/purchase/purchase_contact/PurchaseContact';
import ModalTermsOfUse from '../../components/purchase/modal_terms_of_use/ModalTermsOfUse';
import ModalPurchaseError from '../../components/purchase/modal_purchase_error/ModalPurchaseError';
import ModalGenericError from '../../components/purchase/modal_generic_error/ModalGenericError';
import ModalCouponError from '../../components/purchase/modal_coupon_error/ModalCouponError';
import ModalPurchaseDateError from '../../components/purchase/modal_purchase_date_error/ModalPurchaseDateError';
import ModalPlanRules from '../../components/purchase/modal_plans_rules/ModalPlansRules';
import PurchaseDescription from '../../components/purchase/purchase_description/PurchaseDescription';
import PurchaseContactMobile from '../../components/purchase/purchase_contact/PurchaseContactMobile';
import PurchaseDescriptionMobile from '../../components/purchase/purchase_description/PurchaseDescriptionMobile';
import PurchaseSummary from '../../components/purchase/purchase_summary/PurchaseSummary';
import ModalTravelRenewal from '../../components/purchase/modal_travel_renewal/ModalTravelRenewal';
import ModalTravelRenewalFranchise from '../../components/purchase/modal_travel_renewal_franchise/ModalTravelRenewalFranchise';
import ModalReceptiveProduct from '../../components/purchase/modal_receptive_product/ModalReceptiveProduct';
import ModalNotCovidCoverage from '../../components/purchase/modal_not_covid_coverage';
import CardPurchaseValidation from '../../components/purchase/card_purchase_validation/CardPurchaseValidation';

import BoxAlert from '../../components/common/BoxAlert';
import ModalFailPayment from '../../components/purchase/modal_fail_payment/ModalFailPayment';
import matomoTracker from '../../utils/matomo';

const productIsFranchise = (benefitsList) => {
  const franchise = benefitsList.filter((item) => item.code === '500');

  if (!franchise.length) return false;

  if (franchise[0].coverage.toUpperCase() === 'NAO' || franchise[0].coverage.toUpperCase() === 'NÃO') return false;

  return true;
};

const productIsStudent = (benefitsList) => {
  const student = benefitsList.filter((item) => item.code === '501');

  if (!student.length) return false;

  if (student[0].coverage.toUpperCase() === 'NAO' || student[0].coverage.toUpperCase() === 'NÃO') return false;

  return true;
};

const productIsTravelRenewal = (benefitsList) => {
  if (benefitsList.travel_renewal.toUpperCase() === 'EXCLUSIVE') {
    return true;
  }
  return false;
};

const isReceptiveProduct = (benefitsList) => {
  if (benefitsList.receptive_product) {
    return true;
  }
  return false;
};

class LoadingOverlay extends Component {
  constructor(props) {
    super(props);
    this.style = {
      backgroundColor: 'rgba(255,255,255,0.6)',
      zIndex: '999',
    };

    this.innerStyle = {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    };
  }
  render() {
    return (
      <div className="comp_modalemail" style={this.style}>
        <div style={this.innerStyle}>
          <Loading />
        </div>
      </div>
    );
  }
}

export class Purchase extends Component {
  constructor(props) {
    super(props);
    changeTitle('purchase');
    this.setQuotationParams = this.props.setQuotationParams.bind(this);
    this._checkoutStarted = false;

    this.state = {
      showSameDayAlert: isSameDaySearch(this.props.match.params.begin_date),
    }
  }

  toggleAlert() {
    this.setState({ showSameDayAlert: !this.state.showSameDayAlert });
  }

  componentWillUnmount() {
    document.body.style = '';
  }

  componentWillMount() {
    const { destination } = this.props.match.params;
    const endDate = this.props.match.params.end_date;
    const beginDate = this.props.match.params.begin_date;
    const productCode = this.props.match.params.product_code;
    const queryParam = this.props.location.search


    fetchPaymentMethodsService().then((response) => {
      store.dispatch(getPaymentMethodsAvaliable(response.payment_methods));
    });

    this.setQuotationParams({
      destination,
      end_date: endDate,
      context: 'purchase',
      begin_date: beginDate,
      product_code: productCode,
      queryParams: queryParam,

    });

    getPaymentMethods({
      destination,
      return_date: endDate,
      departure_date: beginDate,
      product_code: productCode,
    });

    getProductCoverage({
      destination,
      end_date: endDate,
      begin_date: beginDate,
      product_code: productCode,
    }).then((json) => {
      if (productIsFranchise(json.benefits) && productIsTravelRenewal(json)) {
        this.props.openModalRenewalFranchise();
        this.props.closeModalFranchise();
        this.props.closeModalTravelRenewal();
        this.props.closeModalReceptiveProduct();
      } else if (productIsFranchise(json.benefits)) {
        this.props.openModalFranchise();
        this.props.closeModalRenewalFranchise();
        this.props.closeModalTravelRenewal();
        this.props.closeModalReceptiveProduct();
      } else if (productIsTravelRenewal(json)) {
        this.props.openModalTravelRenewal();
        this.props.closeModalFranchise();
        this.props.closeModalRenewalFranchise();
        this.props.closeModalReceptiveProduct();
      } else if (isReceptiveProduct(json)) {
        this.props.openModalReceptiveProduct();
        this.props.closeModalFranchise();
        this.props.closeModalRenewalFranchise();
        this.props.closeModalTravelRenewal();
      } else {
        this.props.closeModalFranchise();
        this.props.closeModalRenewalFranchise();
        this.props.closeModalTravelRenewal();
        this.props.closeModalReceptiveProduct();
      }

      if (productIsStudent(json.benefits)) this.props.openModalStudent();
      else this.props.closeModalStudent();
    });

    listBenefits();

    getCouponData(getUrlParams().cupom || this.props.coupon.text, productCode, beginDate, endDate, destination);

    if (getUrlParams().data) getPurchaseData(getUrlParams().data);
    
    matomoTracker.trackPageView('Checkout')
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.prospect.exist && this.props.prospect.exist) {
      this.props.setInfosProspectInPurchase();
    }
  }

  componentWillReceiveProps(props) {
    if (props.purchaseIsValid === 1) {
      props.history.push(formatURL(props.match.params, `/pedido-finalizado/${props.uuid}/status/`));
    }

    if (!this._checkoutStarted && props.productCoverage && props.productCoverage.id) {
      this._checkoutStarted = true;
      dataLayer.pageView('checkout');
      dataLayer.beginCheckout({
        code: props.productCoverage.id,
        name: props.productCoverage.name,
        provider_code: props.productCoverage.provider_name,
        price_with_coupon_discount: props.value,
      });
    }

    dataLayer.raw({
      event: 'payment',
      ecommerce: {
        payment: {
          product: {
            id: props.productCoverage.id,
            provider: props.productCoverage.provider_name,
            name: props.productCoverage.name,
            value: props.value,
          },
        },
      },
    });
  }

  backSearch = (e) => {
    this.props.cleanErrors();
    this.props.history.go(-1);
  };

  render() {
    return (
      <main>
        <div className="comp_main clearfixs">
          <StagePayment />
          <section className="pagamento">
            <div className="component component-pagamento">
              <div className="cards-resumo">
                <CardPurchaseValidation />

                {this.state.showSameDayAlert && (
                  <BoxAlert image="/assets/images/icons/warning-red.svg" altIcon="icon-warning" theme="alert" title="Você está pesquisando um seguro para viajar hoje" onClose={() => this.toggleAlert()}>
                    <span>
                      Sua apólice será válida somente se for emitida antes do início da sua viagem. Para dúvidas, <b><a rel="noopener noreferrer" target="_blank" href="https://segurospromo.com.br/atendimento">fale diretamente com nosso atendimento</a></b>.
                    </span>
                  </BoxAlert>
                )}

                <InsuredRegister />
                <PaymentInfo paramsUrl={this.props.match.params} />
                {this.props.mobile && this.props.stagePurchase === 1 ? (
                  <PurchaseSummary destinations={this.props.destinations} />
                ) : (
                  <div />
                )}

                {this.props.mobile ? (
                  <React.Fragment>
                    <PurchaseContactMobile />
                    <PurchaseDescriptionMobile destinations={this.props.destinations} />
                  </React.Fragment>
                ) : (
                  <PurchaseContact />
                )}
              </div>
            </div>
            {!this.props.mobile && (
              <div className="component component-description">
                <PurchaseDescription />
              </div>
            )}
          </section>
        </div>
        <AccordionGroup />
        <ModalSafetypay />
        <ModalOperatorConfirmation />
        <ModalFranchise />
        <ModalNotCovidCoverage />
        <ModalStudent />
        <ModalTermsOfUse />
        <ModalPurchaseError />
        <ModalGenericError />
        <ModalCouponError />
        <ModalPurchaseDateError />
        <ModalTravelRenewal />
        <ModalTravelRenewalFranchise />
        <ModalReceptiveProduct />
        <ModalPlanRules
          productCoverage={this.props.productCoverage}
          isModalPlanRulesActive={this.props.isModalPlanRulesActive}
          closeModalPlanRules={this.props.closeModalPlanRules}
        />
        <ModalFailPayment
          creditcard={this.props.creditcard}
          isModalFailPaymentActive={this.props.isModalFailPaymentActive}
          closeModalFailPayment={this.props.closeModalFailPayment}
        />


        {this.props.loading === true && <LoadingOverlay />}
      </main>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      coupon: state.purchase.coupon,
      value: state.purchase.purchaseSummary.adult.price,
      uuid: state.purchase.uuid,
      benefits_list: state.purchase.benefits_list,
      purchaseIsValid: state.purchase.purchaseIsValid,
      productCoverage: state.coverage.productCoverage,
      loading: state.purchase.loading,
      mobile: state.mobile.mobileActive,
      isModalPlanRulesActive: state.purchase.isModalPlanRulesActive,
      isModalFailPaymentActive: state.purchase.isModalFailPayment,
      stagePurchase: state.purchase.stagePurchase,
      destinations: state.global.destinations,
      creditcard: state.purchase.creditCard,
      prospect: state.search.prospect,
    }),
    {
      setQuotationParams,
      fetchPlansPurchase,
      openModalFranchise,
      closeModalFranchise,
      closeModalPlanRules,
      closeModalFailPayment,
      openModalStudent,
      closeModalStudent,
      cleanErrors,
      setInfosProspectInPurchase,
      openModalTravelRenewal,
      openModalRenewalFranchise,
      closeModalTravelRenewal,
      closeModalRenewalFranchise,
      openModalReceptiveProduct,
      closeModalReceptiveProduct,
      openModalNotCovidCoverage,
      closeModalNotCovidCoverage,
    }
  )(Purchase)
);



// WEBPACK FOOTER //
// ./src/views/purchase/Purchase.jsx